import React, { useMemo } from "react";
import { Autocomplete, Checkbox, ListItemText, TextField } from "@mui/material";

const GCAutocompleteCheckboxFixSizeUid = ({
  options = [],
  xValue = [],
  xtabIndex = "",
  xDisabled = false,
  label,
  name,
  onKeyUp,
  placeholder,
  error,
  helperText,
  setValue = () => {},
  onChangeCsv = () => {}, // CSV callback
}) => {
  // Helpers: parse and format CSV
  const toArray = (val) =>
    Array.isArray(val)
      ? val
      : typeof val === "string" && val.trim()
      ? val
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean)
      : [];
  const toCsv = (arr) => (Array.isArray(arr) ? arr.join(",") : "");

  const safeUIDs = toArray(xValue);

  const allOptions = useMemo(
    () => [{ Uid: "select-all", Name1: "Select All" }, ...options],
    [options]
  );

  const isAllSelected =
    safeUIDs.length > 0 &&
    options.length > 0 &&
    safeUIDs.length === options.length;

  const commit = (uids) => {
    setValue(uids);
    onChangeCsv(toCsv(uids));
  };

  const handleChange = (_event, newValue) => {
    if (!Array.isArray(newValue)) return;

    const clickedAll = newValue.some((item) => item.Uid === "select-all");

    if (clickedAll) {
      if (isAllSelected) {
        commit([]);
      } else {
        commit(options.map((o) => o.Uid));
      }
      return;
    }

    commit(newValue.map((item) => item.Uid));
  };

  const isSelected = (option) => safeUIDs.includes(option.Uid);

  return (
    <div
      className="GCAutocompleteCheckboxFixSize"
      style={{ background: xDisabled ? "#e9ecef" : "transparent" }}
    >
      <Autocomplete
        tabIndex={xDisabled ? "" : xtabIndex}
        disabled={xDisabled}
        multiple
        size="small"
        options={allOptions}
        getOptionLabel={(option) => option?.Name1 || ""}
        value={allOptions.filter(
          (opt) => opt.Uid !== "select-all" && safeUIDs.includes(opt.Uid)
        )}
        isOptionEqualToValue={(option, value) => option.Uid === value.Uid}
        onChange={handleChange}
        disableCloseOnSelect
        ListboxProps={{
          sx: { maxHeight: 260, overflowY: "auto", paddingY: 0 },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            name={name}
            placeholder={placeholder}
            onKeyUp={onKeyUp}
            error={error}
            helperText={helperText}
            size="small"
            InputLabelProps={{ shrink: true }}
            sx={{
              fontSize: "10px",
              "& .MuiOutlinedInput-root": {
                maxHeight: "32px",
                overflowY: "auto",
                border: "1px solid #ddd",
                padding: "0px !important",
                minWidth: "0px !important",
              },
              "& .MuiAutocomplete-input": {
                padding: "7.5px 4px 7.5px 5px !important",
              },
            }}
          />
        )}
        renderOption={(props, option) => {
          if (option.Uid === "select-all") {
            return (
              <li {...props} style={{ display: "flex", alignItems: "center" }}>
                <Checkbox
                  size="small"
                  checked={isAllSelected}
                  indeterminate={
                    safeUIDs.length > 0 && safeUIDs.length < options.length
                  }
                  tabIndex={-1}
                />
                <ListItemText primary="Select All" />
              </li>
            );
          }
          return (
            <li {...props} style={{ display: "flex", alignItems: "center" }}>
              <Checkbox
                size="small"
                checked={isSelected(option)}
                tabIndex={-1}
              />
              <ListItemText primary={option?.Name1} />
            </li>
          );
        }}
      />
    </div>
  );
};

export default GCAutocompleteCheckboxFixSizeUid;
